// extracted by mini-css-extract-plugin
export var favoriteButton = "image-slider-module--favorite-button--Qwxt8";
export var favoriteButtonActive = "image-slider-module--favorite-button-active--ssiU9";
export var navBtn = "image-slider-module--nav-btn--R3xSH";
export var next = "image-slider-module--next--1+A6G";
export var padlock = "image-slider-module--padlock--qZhr+";
export var prev = "image-slider-module--prev--F-p9t";
export var slide = "image-slider-module--slide--68d+p";
export var sliderContainer = "image-slider-module--slider-container--sqt2Q";
export var sliderContent = "image-slider-module--slider-content--rnL4E";